import { render } from "./lists_card.vue?vue&type=template&id=cb7330aa"
import script from "./lists_card.js?vue&type=script&lang=js"
export * from "./lists_card.js?vue&type=script&lang=js"

import "./lists_card.vue?vue&type=style&index=0&id=cb7330aa&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__